import React from "react";
import { Image } from '@chakra-ui/react'
import logo from "assets/img/logo-hr.png";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
     
  <Image src={logo} mb="40px" height='100px' alt='logo' />

     
    </Flex>
  );
}

export default SidebarBrand;
